import React from 'react'
import classNames from 'classnames'

import styles from './Tabs.module.scss'

const Tabs = ({ list = [], activeTabId, onChange }) => {
    if (list.length < 2) return null

    return (
        <ul className={styles.tabs}>
            {list.map(item => (
                <li
                    className={classNames(styles.tab, { [styles.isActiveTab]: item.id === activeTabId })}
                    onClick={() => onChange(item.id)}
                >
                    {item.label}
                </li>
            ))}
        </ul>
    )
}

export default Tabs
